import script from "./HomeDash.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeDash.vue?vue&type=script&setup=true&lang=js"

import "./HomeDash.vue?vue&type=style&index=0&id=70f51aa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f51aa4"]])

export default __exports__